import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

/**
 * Formulario de contacto (SEION).
 * Los campos los aporta un formulario dinámico elegido en el panel; el envío
 * sigue el mismo flujo que mod-custom-form (endpoint /web/custom-form/send-form).
 */
export class ModAgentsSix extends ModuleComponent{

    ready(){
        super.ready();
        this.$form = this.$root.find(".js-form");
        if(this.$form.length === 0) return;
        this.isSendingForm = false;

        this.findMember("submit").click(
            () => {
                this.$form.submit();
            }
        );

        this.$form.submit(
            (ev) => {
                ev.preventDefault();
                this.$form.checkRestrictions().then(
                    (isOk) => {
                        if(isOk){
                            if(this.isSendingForm){
                                return;
                            }
                            let values = this.$form.getValues();
                            //limpia los campos ocultos por binding
                            const $hiddenFields = $(this.$form.find(".js-form-field[data-applied-binding='hide']"));
                            $hiddenFields.each((index,item) => {
                                delete values[$(item).data("name")];
                            });
                            this.isSendingForm = true;
                            GvfService.endpoint(
                                "/web/custom-form/send-form",
                                {formData: values}
                            ).then(
                                (resp) => {
                                    if(resp.message){
                                        this.findMember("web-card-inner")
                                            .addClass("is-ok-message")
                                            .html("<h2>"+resp.message+"</h2>");
                                    }
                                    if(resp.url){
                                        GvfService.delay(2000).then(
                                            () => {
                                                window.location = resp.url;
                                            }
                                        );
                                    }
                                }
                            ).catch(
                                (resp) => {
                                    UtilsService.alertEndpointResponse(resp);
                                }
                            ).finally(
                                () => {
                                    this.isSendingForm = false;
                                }
                            );
                        }else{
                            const $err = this.$form.find(".web-form-field__error:visible");
                            if($err.length > 0){
                                const position = $err.position();
                                if(position) this.findMember("web-card-inner").scrollTop(position.top);
                            }
                        }
                    }
                );
            }
        );
    }
}
